import {Pipe, PipeTransform} from "@angular/core";


@Pipe({name: 'categoriaFilter', standalone: false})
export class MetasFiltrarCategoriaPipe implements PipeTransform {
    transform(objetos: any[], categoria: number[]) {
        return objetos.filter(obj => categoria.indexOf(obj.categoriaID) > -1);
    }
}